<template>
  <div class='selector'>
    <v-btn
      v-on:click='$emit("selector-clicked", index)'
      v-bind:class='buttonClass(state)'
      :disabled='disabled'
      class='overlay-button ma-0 pa-0'
      icon
    >
      <div v-if='selected'>
        <svg width='40' height='40' class='shadow'>
          <circle
            cx='20' cy='20' r='16' stroke-width='4'
            :stroke='svgColor(state)' fill-opacity='0'
          />
          <circle cx='20' cy='20' r='10' :fill='svgColor(state)'  />
          <text
            v-if='text'
            x='50%' y='50%'
            text-anchor='middle' dy='.35em'
            fill='white'
          >{{ text }}</text>
        </svg>
      </div>
      <div v-else>
        <svg height='40' width='40' class='shadow'>
          <circle cx='20' cy='20' r='12' :fill='svgColor(state)'/>
          <text
            v-if='text'
            x='20' y='20'
            text-anchor='middle' dy='.35em'
            fill='white'
          >{{ text }}</text>
        </svg>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Selector',
  props: ['state', 'index', 'selected', 'text', 'disabled'],
  data() {
    return {
      styles: ['green--text ', 'red--text ', 'orange--text ', 'grey--text '],
      svgStyles: ['#388E3C ', '#D32F2F ', '#F57C00 ', '#616161 '],
    };
  },
  methods: {
    buttonClass(state) {
      let style = '';
      if (state === 0) {
        style += this.styles[0];
      } else if (state === 1) {
        style += this.styles[1];
      } else if (state === 2) {
        style += this.styles[2];
      } else if (state === 3) {
        style += this.styles[3];
      }

      style += ' transparent text--darken-2 ';
      return style;
    },
    svgColor(state) {
      let style = '';
      if (state === 0) {
        style += this.svgStyles[0];
      } else if (state === 1) {
        style += this.svgStyles[1];
      } else if (state === 2) {
        style += this.svgStyles[2];
      } else if (state === 3) {
        style += this.svgStyles[3];
      }

      style += ' ';
      return style;
    },
  },
};
</script>

<style>
.img-overlay {
  position: relative;
}

.button-holder {
  position: absolute;
}

.overlay-button {
  width: 40px;
  height: 40px;
}

.selector {
  position: absolute;
  top: -20px;
  left: -20px;
}

.shadow {
  -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .2));
  filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .2));
  /* Similar syntax to box-shadow */
}

.inline-selector {
  position: relative;
  float: left;
}

.reverse-selector {
  position: relative;
  float: left;
  top: -10px;
  left: 0px;
}

</style>
